import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

export async function deleteTemplate(params: {
  customerId: number;
  templateId: number;
}): Promise<void> {
  const { customerId, templateId } = params;
  await Axios.delete(
    DELETE_URL(customerId.toString(), templateId.toString())
      .deleteExportBoTemplates
  );
}

export function useDeleteExportBoTemplate() {
  const queryClient = useQueryClient();

  return useMutation<
    void,
    AxiosError<BaseError>,
    { customerId: number; templateId: number }
  >(deleteTemplate, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(QueryKeys.exportTemplates());
    },
    useErrorBoundary: false
  });
}
